import api from "../service/api";


export async function loginToLms() {
    
    const newTab = window.open("about:blank", "_blank");

    try {
        const response = await api.post("tms/tms-sso/generate");

        const { url } = response.data;


        if (newTab) {
            newTab.location.href = url;
        } else {
            window.location.href = url;
        }
    } catch (error) {
        if (newTab) newTab.close();

        if (error.response?.status === 403) {
            alert("You do not have permission to access LMS.");
        } else {
            alert("Unable to log in to LMS right now. Please try again.");
        }

        console.error("SSO login failed:", error);
    }
}
